import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-utility-lib',
  template: `
    <p>
      utility-lib works!
    </p>
  `,
  styles: []
})
export class UtilityLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
